import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { DeleteEmailsDialog } from "../-components/delete-emails-dialog"
import { bulkIdsSearchSchema, emailsSearchSchema } from "../-lib/search"
import { useEmailsSelectionContext } from "../route"

export const Route = createFileRoute(
  "/_layout/quoting_/emails/_list/delete/bulk",
)({
  component: DeleteEmailsBulkModal,
  validateSearch: (search) => bulkIdsSearchSchema.parse(search),
  beforeLoad: async ({ context: { queryClient }, search }) => {
    await requirePermission(queryClient, "email:delete", "/")
    if (search.ids.length === 0) {
      throw redirect({ to: "/quoting/emails", search: true })
    }
  },
})

function DeleteEmailsBulkModal(): React.ReactElement {
  const { ids } = Route.useSearch()
  const navigate = useNavigate()
  const { clearEmailSelection } = useEmailsSelectionContext()

  return (
    <DeleteEmailsDialog
      emailIds={ids}
      onClose={() =>
        navigate({
          to: "/quoting/emails",
          search: (previous) => emailsSearchSchema.parse(previous),
        })
      }
      onDeleted={clearEmailSelection}
    />
  )
}
